import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        name: '/HomeIndex',
        component: () => import('../layout/HomeIndex.vue') // 确保该组件存在

    },
    {
        path: '/appointment',
        name: 'HeaderAppointment',
        component: () => import('../layout/HeaderAppointment.vue') ,
        props: true,
        beforeEnter: (to, from, next) => {
            window.scrollTo(0, 0);
            next();
        }
    },
    {
        path: '/appointmentCompleted',
        name: 'AppointmentCompleted',
        component: () => import('../layout/AppointmentCompleted.vue') ,// 确保该组件存在
        props: true,
        beforeEnter: (to, from, next) => {
            window.scrollTo(0, 0);
            next();
        }
    },
    // PC 端（合并自 huayin-pc 项目）统一挂在 /pc 前缀下面，跟移动端这边默认的路由
    // 完全分开、互不冲突——移动端不用改任何现有路由。具体去移动端还是 PC 端由
    // src/main.js 里那段"根据设备判断、自动重定向"的逻辑决定，这里只是把两套页面
    // 都注册好，页面组件/图片/store 也各自在 -pc 结尾的目录里，不跟移动端混在一起
    {
        path: '/pc',
        name: 'PcHomeIndex',
        component: () => import('../layout-pc/HomeIndex.vue')
    },
    {
        path: '/pc/appointment',
        name: 'PcKanonAppointment',
        component: () => import('../layout-pc/KanonAppointment.vue'),
        beforeEnter: (to, from, next) => {
            window.scrollTo(0, 0);
            next();
        }
    },
    {
        path: '/pc/appointmentCompleted',
        name: 'PcKanonAppointmentDone',
        component: () => import('../layout-pc/KanonAppointmentDone.vue'),
        beforeEnter: (to, from, next) => {
            window.scrollTo(0, 0);
            next();
        }
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

// 纯前端 SPA，没有服务端渲染，"进移动端还是 PC 端"这件事只能在浏览器里判断——
// 读 User-Agent 里有没有常见移动设备关键字，没有就按 PC 处理。默认域名走的是移动端
// 路由（不带 /pc），所以 PC 设备访问这些路径时要自动跳到对应的 /pc 路径；反过来，
// 移动设备如果访问了 /pc 开头的路径（比如别人分享了链接），也自动跳回对应的移动端路径。
// 注意：iPadOS 的 Safari 从 13 开始 UA 会伪装成桌面 Mac，这里检测不出来，会被当成 PC——
// 这是已知的局限，先不特殊处理
function isPcDevice() {
    return !/Android|iPhone|iPad|iPod|Mobile|IEMobile|BlackBerry|Opera Mini/i.test(navigator.userAgent);
}

router.beforeEach((to, from, next) => {
    const pcDevice = isPcDevice();
    const isPcRoute = to.path === '/pc' || to.path.startsWith('/pc/');

    if (pcDevice && !isPcRoute) {
        // PC 设备走到了移动端的路径，跳去对应的 /pc 路径；根路径 '/' 对应 '/pc'，
        // 不是 '/pc/'（避免多一个没用的尾部斜杠）
        const pcPath = to.path === '/' ? '/pc' : '/pc' + to.path;
        next({ path: pcPath, query: to.query, hash: to.hash, replace: true });
    } else if (!pcDevice && isPcRoute) {
        // 移动设备走到了 /pc 路径，跳回对应的移动端路径
        const mobilePath = to.path.replace(/^\/pc/, '') || '/';
        next({ path: mobilePath, query: to.query, hash: to.hash, replace: true });
    } else {
        next();
    }
});

export default router;
